import PhaseTask from './phase_task';
import { connect } from 'react-redux';
import PhaseType from 'types/phase';
import PropTypes from 'prop-types';
import TaskType from 'types/task';
import { updatePhaseTask, fetchPhaseDocuments, clearValidationErrors } from 'actionCreators';
import documentUploadShape from 'types/documentUpload';


export class UploadedToImsPhaseTask extends PhaseTask {

  onClick = () => {
    const data = this.data();

    const task = {
      status: 'complete',
    };
    this.props.updatePhaseTask(
      this.props.phase.id,
      this.props.task.slug,
      { task, ...data },
    ).catch(() => this.setState({ errorModalActive: true }));
    this.childHandleTasksClose();
  }

  componentWillMount() {
    const { phase } = this.props;

    this.props.fetchPhaseDocuments(phase.id);
  }

  data() {
    const { documents } = this.props;
    const docOptions = documents.data
      .filter(doc => doc.document_type === 'Assessment/Refigure')
      .map(doc => (
        {
          value: doc.id,
          label: `${doc.document_name}`,
        }
    ));
    return {
      data: { documents: docOptions.map(n => n.value) },
    };
  }
}

UploadedToImsPhaseTask.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  fetchPhaseDocuments: PropTypes.func.isRequired,
  clearValidationErrors: PropTypes.func.isRequired,
  documents: PropTypes.shape({
    loaded: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(documentUploadShape).isRequired,
  }),
};

const uploadedToImsPhaseTask = connect(state => ({
  documents: state.phase.documents,
}), {
  updatePhaseTask, fetchPhaseDocuments, clearValidationErrors })(UploadedToImsPhaseTask);

export { uploadedToImsPhaseTask as review_send_to_store,
    uploadedToImsPhaseTask as refigure_send_to_store };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/uploaded_to_ims.jsx